import React from "react";
import { Field, FieldArray } from "redux-form";
import { FormField, Loader } from "pickups-ui-library";
import { Button, Label, FormGroup } from "reactstrap";
import FormNavigation from "../navigation.component";
import { requiredValidate } from "../../helpers";
import { formatPhone } from "utils/helpers";

const RegisterUser = (props) => {
  const { handleSubmit, continueAsGuest, phoneNumber } = props;

  return (
    <form onSubmit={handleSubmit}>
      <h4 className={"p-2 pl-4 pr-4"}>
        Create an account for future donations?
      </h4>
      <p className={"pl-4 pr-4"}>
        Add a password to gain access to our donotion dashboard. Track your
        upcoming pickup and more.
      </p>
      <div />
      <div className={"box p-4"}>
        {/*<p>Schedule donations in 1 click and manage all of your donations in our frequent donor section, just add a password.</p>*/}
        <FormGroup>
          <Label>Phone Number</Label>
          <div className={"form-control"}>{formatPhone(phoneNumber)}</div>
        </FormGroup>
        {/*<Field name="phone" type="text" component={FormField} label="Phone Number" format={formatPhone} normalize={phoneNormalize} placeholder="(xxx) xxx - xxxxx"/>*/}
        <Field
          name="password"
          type="password"
          component={FormField}
          label="Password"
          placeholder=""
          validate={[requiredValidate]}
        />
        {/*<Field name="password2" type="password" component={FormField} label="Confirm Password" placeholder=""/>*/}

        <a
          className={"link"}
          style={{ color: "#6EACE8", cursor: "pointer" }}
          onClick={continueAsGuest}
        >
          No thanks, Continue as a guest
        </a>
      </div>
      <FormNavigation nextLabel={"Register"} {...props} />
      <div style={{ margin: 10, fontSize: "14px" }}>
        By clicking Register, you agree to our{" "}
        <a target="_blank" href={process.env.REACT_APP_PRIVACY_POLICY_URL}>
          {" "}
          Privacy Policy
        </a>{" "}
        and{" "}
        <a target="_blank" href={process.env.REACT_APP_SMS_POLICY_URL}>
          SMS Policy
        </a>
        . You may receive SMS Notifications from us and can opt out any time.
      </div>
    </form>
  );
};

export default RegisterUser;
